export default __webpack_public_path__ + "static/media/image27.33860ae5.jpg";